export default __webpack_public_path__ + "img/logo.469d47b6.svg";